/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { StoreHour } from '../features/stores/storage/stores.types';

export const formatHours = (hours: StoreHour | undefined) => {
  return hours?.isClosed ? 'Closed' : `${formatAMPM(hours?.open)} -  ${formatAMPM(hours?.close)}`;
};

const formatAMPM = (time: string | undefined) => {
  if (time === undefined) return;

  let hours = parseInt(time.slice(0, 2));
  const ampm = hours >= 12 ? 'pm' : 'am';
  const minutes = time.slice(3, 5);

  hours %= 12;
  hours = hours || 12;

  return `${hours}:${minutes}${ampm}`;
};
